import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { LayoutDashboard, Package, FolderOpen, Tag, Settings, LogOut } from 'lucide-react';

const AdminLayout = ({ children }) => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  const navItems = [
    { to: '/admin/dashboard', icon: LayoutDashboard, label: 'Dashboard' },
    { to: '/admin/produtos', icon: Package, label: 'Produtos' },
    { to: '/admin/categorias', icon: FolderOpen, label: 'Categorias' },
    { to: '/admin/ofertas', icon: Tag, label: 'Ofertas' },
    { to: '/admin/configuracoes', icon: Settings, label: 'Configurações' },
  ];

  return (
    <div className="min-h-screen flex" style={{ backgroundColor: '#F8F9FA' }}>
      {/* Sidebar */}
      <aside className="w-64 min-h-screen fixed left-0 top-0" style={{ backgroundColor: '#273e82' }}>
        <div className="p-6">
          <div className="flex justify-center mb-8">
            <img 
              src="/logo.png" 
              alt="Central de Ferragens" 
              className="w-[180px] h-[70px] mb-2"
            />
          </div>
          
          <nav className="space-y-2">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-4 py-3 rounded-lg transition-all ${isActive
                    ? 'bg-[#fef000] text-[#273e82] font-bold'
                    : 'text-white hover:bg-[#3B5C85]'
                  }`
                }
                data-testid={`nav-${item.label.toLowerCase()}`}
              >
                <item.icon size={20} />
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
        
        <div className="absolute bottom-0 left-0 right-0 p-6">
          <button
            onClick={handleLogout}
            className="flex items-center gap-3 px-4 py-3 rounded-lg text-white hover:bg-red-500 transition-all w-full"
            data-testid="logout-button"
          >
            <LogOut size={20} />
            Sair
          </button>
        </div>
      </aside>
      
      {/* Main Content */}
      <main className="flex-1 ml-64 p-8">
        {children}
      </main>
    </div>
  );
};

export default AdminLayout;